import React from 'react'
import classNames from 'classnames'

const amountArray = (() => {
  let amountArray = []
  for (let i = 0; i < 100; i++)
    amountArray[i] = i + 1
  return amountArray
})()

const TimeSelector = ({
  selOptions, onInput, onSelect, defaultVal, preselect, onKeyUp, onBlur
}) => (
  <div className="form-inline">
    <select
      className='duration-selector left text-blue'
      value={defaultVal.amount}
      onChange={onInput}
      onBlur={onBlur}
    >
    {amountArray.map((opt, index) => (
        <option value={opt} key={opt}>
          {opt}
        </option>
      ))}
    </select> 
    <select
      value={defaultVal.unit}
      className={classNames(
        'duration-selector right',
        {'text-blue': defaultVal.unit},
        {'text-gray': !defaultVal.unit}
      )}
      onChange={onSelect}
      onBlur={onBlur}
    >
      {preselect ? null : 
        <option disabled selected>select unit</option>}
      {selOptions.map((opt, index) => (
        <option value={opt} key={opt}>
          {(defaultVal.amount === '1') ? opt.substring(0, opt.length -1) : opt}
        </option>
      ))}
    </select>
  </div>
)

export { TimeSelector as default }



// WEBPACK FOOTER //
// ./assets/common/components/TimeSelector.js